<template>
  <div class="sms-view">
    <Navigation />
    <div class="view-content">
      <SmsManagement />
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation';
import SmsManagement from '@/components/SmsManagement';

export default {
  name: 'SmsAdminView',
  components: {
    Navigation,
    SmsManagement
  }
};
</script>

<style scoped>
.sms-view {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f3f6f4;
}

.view-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>
